import { createContext, useContext, useEffect, useCallback, useState, useRef } from "react";
import { chatApi } from "@/lib/api";

const ChatUnreadContext = createContext({ unreadCount: 0, refresh: () => {}, markRead: () => {} });

export const useChatUnread = () => useContext(ChatUnreadContext);

export const ChatUnreadProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const timer = useRef(null);

  const refresh = useCallback(async () => {
    try {
      const res = await chatApi.getUnreadCount();
      setUnreadCount(res.data?.unread || 0);
    } catch (e) {
      console.debug("Ungelesen-Zähler konnte nicht geladen werden:", e);
    }
  }, []);

  const markRead = useCallback(async () => {
    setUnreadCount(0);
    try {
      await chatApi.markRead();
    } catch (e) {
      console.debug("Als-gelesen-Markierung fehlgeschlagen:", e);
    }
  }, []);

  useEffect(() => {
    refresh();
    timer.current = setInterval(refresh, 25000);
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    return () => {
      if (timer.current) clearInterval(timer.current);
      window.removeEventListener("focus", onFocus);
    };
  }, [refresh]);

  return (
    <ChatUnreadContext.Provider value={{ unreadCount, refresh, markRead }}>
      {children}
    </ChatUnreadContext.Provider>
  );
};
